export default "__VITE_ASSET__BjXr5npH__"